// The purpose of this file is to configuration variables for the application.
// Note that they are kept separate from the implementation of the system that stores and retrieves data,
// which is located in the 'core' directory.

// Grab a reference to the application data store object.
var dataStore = app.data;

// Use custom scroll bars for jda autocomplete plugin.
dataStore.set('config.autocompleteBars', true);

// Use custom scroll bars for dropdowns plugin
dataStore.set('config.dropdownBars', false);

// Youtube api key
dataStore.set('config.youtubeApiKey', 'AIzaSyCnTJasZNZHqoUhfDMev92xO-tEp7iJ94A');